import { useEffect } from "react";
import { useLocation } from "react-router-dom"

export const Error404 = () => {
  const path = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.location.href = '/'
    }, 3000);
  }, [])
  return (
    <div className="w-screen h-screen overflow-hidden flex flex-col justify-center items-center gap-4">
      <div className="w-1/2 h-1/2 flex flex-col justify-center items-center gap-4 bg-white/75 rounded-lg drop-shadow-md font-bold text-black text-xl">
        <span>Error 404 !</span>
        <span>Page Not Found </span>
        <span>You will be redirected to Home page in 3 seconds !</span>
        <div className="mt-4 w-8 h-8 border-4 border-t-transparent border-black rounded-full animate-spin"></div>
      </div>
    </div>
  )
}
